const VARIANTS = {
  YELLOW: "yellow",
  DEEP_ORANGE: "deepOrange",
  ORANGE: "orange",
  GOLDEN: "golden",
  GOLDEN_OUTLINE: "goldenOutline",
  PINK: "pink",
};

export { VARIANTS };
